<template>
  <div>
    <section class="content-header">
      <h1>My Packages</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Transactions</a>
        </li>
        <li class="breadcrumb-item active">My Packages</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="box box-solid bg-dark">
            <div class="box-header with-border">
              <h3 class="box-title">Packs Detail</h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-bordered no-margin">
                  <thead>
                    <tr class="bg-dark ">
                      <th class="text-white">ID</th>
                      <th class="text-white">Pack</th>

                      <th class="text-white text-center">Status</th>
                      <th class="text-white text-right">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in tableData" :key="index">
                      <td class="text-left">
                        <a href="#" class=" hover-warning">{{ item.id }}</a>
                      </td>
                      <td class="text-left">{{ item.plan.name }}</td>
                      <td class="text-center">
                        <span
                          class="label"
                          :class="
                            (item.subscription_status === 'active' &&
                              'label-success') ||
                              (item.subscription_status === 'expired' &&
                                'label-danger') ||
                              (item.subscription_status === 'cancelled' &&
                                'label-warning')
                          "
                        >
                          {{
                            (item.subscription_status === "active" &&
                              "Active") ||
                              (item.subscription_status === "expired" &&
                                "Ended") ||
                              (item.subscription_status === "cancelled" &&
                                "Canceled")
                          }}
                        </span>
                      </td>
                      <td class="text-right">
                        {{ item.created_at | formatDate("MMMM Do YYYY") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { formatDollar, formatDate } from "@/filters";

export default {
  name: "subcriptions",
  props: {
    title: String,
  },
  data() {
    return {
      type: "dark",
      loading: false,
      tableData: [],
      last_subs: {},
    };
  },
  filters: { formatDollar, formatDate },
  created() {
    this.last_subs = this.$store.getters.currentUser.last_subs;
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/subscriptions", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          },
        })
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
